import React, { useState } from "react";
import { Modal, ConfigProvider, Divider, Tabs, Empty } from "antd";
import OrderDetailsItemComponent from "../OrderDetailsItemComponent";
import moment from "moment";

function ViewOrderLogModal({ openModal, records }) {
  const items = [
    {
      key: "1",
      label: "Edit Logs",
      children: (
        <div className="flex flex-col">
          {records?.editLogs?.length > 0 ? (
            records?.editLogs?.map((item, index) => {
              return (
                <div key={item.id + 'xx'} className="flex flex-row my-[6px] items-baseline">
                  <div>{index + 1}.</div>
                  <div className="mx-[8px] font-ubold">{`Edited by ${item.staff.name}`}</div>
                  <div className="text-pregray text-xs">
                    at {moment(item.editedAt).format("YYYY-MM-DD HH:mm:ss")}
                  </div>
                </div>
              );
            })
          ) : (
            <Empty />
          )}
        </div>
      ),
    },
    {
      key: "2",
      label: "Status Logs",
      children: (
        <div className="flex flex-col">
          {records?.statusLogs?.length > 0 ? (
            records?.statusLogs?.map((item, index) => {
              return (
                <div
                  key={item._id + 'yy'}
                  className="flex flex-row my-[6px] items-baseline"
                >
                  <div>{index + 1}.</div>
                  <div className="mx-[8px] font-ubold">{`Edited by ${item.staff.name}`}</div>
                  <div className="text-pregray text-xs">
                    at {moment(item.changedAt).format("YYYY-MM-DD HH:mm:ss")}
                  </div>
                </div>
              );
            })
          ) : (
            <Empty />
          )}
        </div>
      ),
    },
  ];
  const handleOk = () => {
    records.onCancel();
  };
  const onChange = (key) => {};
  return (
    <ConfigProvider
      theme={{
        components: {
          Button: {
            defaultHoverBorderColor: "#FFD700",
            defaultHoverColor: "#000000",
            fontFamily: "ubold",
          },
        },
      }}
    >
      <Modal
        open={openModal}
        okButtonProps={{
          style: {
            backgroundColor: "#FFD700",
            color: "#000000",
            fontFamily: "ubold",
          },
        }}
        onOk={handleOk}
        onCancel={handleOk}
        width={660}
      >
        <div className="flex flex-col font-uregular">
          <div className="text-2xl font-ubold">Order Log Details</div>
          <Divider />
          <ConfigProvider
            theme={{
              components: {
                Tabs: {
                  itemSelectedColor: "#FCBD10",
                  itemHoverColor: "#FCBD10",
                  inkBarColor: "#FCBD10",
                },
              },
            }}
          >
            <Tabs
              className="font-uregular"
              defaultActiveKey="1"
              items={items}
              onChange={onChange}
            />
          </ConfigProvider>
          <Divider />
        </div>
      </Modal>
    </ConfigProvider>
  );
}

export default ViewOrderLogModal;
